import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type UserState } from './state'

export const useUserStore = defineStore('user', {
  state: useState,
  getters: { ...Getters },
  actions: { ...Actions },
})

export type UserStoreContext = ReturnType<typeof useUserStore>